import { render, staticRenderFns } from "./TestimonialDetailsDialog.vue?vue&type=template&id=dcb55b3a&scoped=true&"
import script from "./TestimonialDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./TestimonialDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialDetailsDialog.vue?vue&type=style&index=0&id=dcb55b3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb55b3a",
  null
  
)

export default component.exports